import DeliveryRegionRoutingAllComponent from './delivery_region_routing.all.component';

const DeliveryRegionRoutingAllModule = angular.module('deliveryRegionRoutingAll', [])

    .component('deliveryRegionRoutingAll', DeliveryRegionRoutingAllComponent)

    .name;

export default DeliveryRegionRoutingAllModule;


// WEBPACK FOOTER //
// ./client/app/components/delivery_region_routing/all/index.js